<template>
  <div>
    {{ rowData.files_total }}
  </div>
</template>

<script>
export default {
  props: ["rowData"],
};
</script>
